<!--
 * @Author: 李明明
 * @Date: 2022-07-28 09:33:50
 * @LastEditTime: 2024-11-25 17:05:23
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/App.vue
 * 代码版权方：'政府采购信息网'
-->
<template>
  <el-dialog
    title="切屏限制提示"
    v-model="cutVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="650px"
  >
    <span>
      <p
        style="
          line-height: 32px;
          font-size: 16px;
          font-weight: 900;
          color: #000000;
        "
      >
        已有
        <span style="color: #df3031">{{ switchScreenCount }}次</span>
        切屏操作，达到
        <span style="color: #df3031">{{ examLimitSwitchScreenCount }}次</span>
        时系统将自动交卷。
      </p>
    </span>
    <template #footer>
      <el-button @click="cutVisible = false">确 定</el-button>
    </template>
  </el-dialog>

  <el-dialog
    title="切屏限制提示"
    v-model="subVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="650px"
  >
    <span>
      <p
        style="
          line-height: 32px;
          font-size: 16px;
          font-weight: 900;
          color: #000000;
        "
      >
        达到
        <span style="color: #df3031">{{ examLimitSwitchScreenCount }}次</span>
        切屏操作限制，已自动交卷
      </p>
    </span>
    <template #footer>
      <el-button @click="subVisible = false">确 定</el-button>
    </template>
  </el-dialog>
  <!-- <div class="advert_mask" v-if="advert_show">
    <div class="advert_wrap">
      <p>{{ advert_time }}s</p>
      <a href="https://www.jcaitt.com" target="_blank">
        <img src="@/assets/images/yct_advert_mask.png" alt="" />
      </a>
      <div class="close" @click="advert_show = false">
        <el-icon>
          <CircleClose />
        </el-icon>
      </div>
    </div>
  </div> -->
  <!-- browser-tip 页面单独显示，占满屏幕 -->
  <div v-if="route.path === '/browser-tip'" class="browser-tip-fullscreen">
    <router-view />
  </div>
  <!-- 其他页面正常显示 -->
  <template v-else>
    <!-- 独立子应用 -->
    <div id="micro-container2" v-show="aloneShow"></div>
    <el-container class="app-wrap" v-show="!aloneShow">
      <el-header>
        <Head></Head>
      </el-header>
      <el-container style="min-height: 100vh">
        <el-aside width="200px" v-if="asideShow">
          <Aside></Aside>
        </el-aside>
        <el-container style="flex-wrap: wrap">
          <div class="bread" v-if="asideShow">
            <div class="example-container">
              <span class="bread_title">当前位置:</span>
              <el-breadcrumb>
                <el-breadcrumb-item
                  v-for="(item, index) in breadList"
                  :key="index"
                  :to="{ path: item.path }"
                  >{{ item.meta.title }}</el-breadcrumb-item
                >
              </el-breadcrumb>
            </div>
          </div>
          <el-main style="min-height: 1100px; background-color: #fbfcfe">
            <router-view />
            <!-- 新添加，微应用的容器 -->

            <div class="main-content" v-show="asideShow">
              <div class="resource_wrap" v-show="store.state.resourceLoading">
                <el-empty description="资源加载中..." style="margin-top: 50px" />
              </div>
              <div
                id="micro-container"
                v-show="store.state.resourceLoading == false"
              ></div>
            </div>
          </el-main>
        </el-container>
      </el-container>

      <el-footer>
        <Foot></Foot>
      </el-footer>
    </el-container>
  </template>
  <!-- 未支付订单提醒 -->
  <el-dialog
    title="提示"
    v-model="notPayVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="650px"
  >
    <span>
      <p>您有未支付订单，是否去查看订单</p>
    </span>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="notPayVisible = false">取 消</el-button>
        <el-button type="primary" @click="goOrder">去看看</el-button>
      </span>
    </template>
  </el-dialog>
  <!-- 山西考试提醒弹窗 -->
  <el-dialog
    v-model="shanxiDialog"
    width="840px"
    center
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <template #header="{ close, titleId, titleClass }">
      <div class="my-header">
        <h3
          style="font-size: 28px; margin-top: 6px"
          :id="titleId"
          :class="titleClass"
        >
          政府采购从业人员考试提醒
        </h3>
      </div>
    </template>
    <div class="shanxi_tip_wrap">
      <div class="shanxi_division">
        <p>
          山西省财政厅将于1月20日组织集中考试，所有人员同一时间考试，考试时长为2小时，需使用带有摄像功能的电脑，详细通知请登录山西省政府采购网查看：
          <a
            href="http://www.ccgp-shanxi.gov.cn/site/detail?parentId=138005&articleId=ncyKcWrn3st2SDOBMsgikA==&utm=site.site-PC-31363.947-pc-websitegroup-newsListNotice-row-front.14.eb846d20b51111ee94ff61e71b9eeaf0"
            target="_blank"
          >
            http://www.ccgp-shanxi.gov.cn/site/detail?parentId=138005&articleId=ncyKcWrn3st2SDOBMsgikA==&utm=site.site-PC-31363.947-pc-websitegroup-newsListNotice-row-front.14.eb846d20b51111ee94ff61e71b9eeaf0
          </a>
        </p>
      </div>
      <div class="shanxi_division">
        <p>代理机构从业人员考试链接（链接1月20日生效）：</p>
        <a
          href="https://e-learning.zcygov.cn/exam/detail?id=886"
          target="_blank"
        >
          https://e-learning.zcygov.cn/exam/detail?id=886</a
        >
      </div>
      <div class="shanxi_division">
        <p>评审专家考试链接（链接1月20日生效）：</p>
        <a
          href="https://e-learning.zcygov.cn/exam/detail?id=885"
          target="_blank"
          >https://e-learning.zcygov.cn/exam/detail?id=885</a
        >
      </div>
      <div class="shanxi_division">
        <p>
          为保证用户能够顺畅完成考核工作，建议所有用户提前访问测试链接验证考试环境、熟悉考试流程及操作：
          <a
            href="https://e-learning.zcygov.cn/exam/detail?id=884"
            target="_blank"
            >https://e-learning.zcygov.cn/exam/detail?id=884</a
          >
        </p>
      </div>

      <p>感谢每一位同行的信任，祝所有同行成功上岸～</p>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="shanxiDialog = false">
          确认
        </el-button>
      </span>
    </template>
  </el-dialog>
  <!-- 考试说明弹窗 -->
  <ExamDescDialog />
</template>
<script setup>
import Head from "@/components/public/head.vue";
import Foot from "@/components/public/foot.vue";
import Aside from "@/components/public/aside.vue";
import { useRoute, useRouter } from "vue-router";
import { getCookie, clearCookie } from "@/utils/cookie.js";
import { useStore } from "vuex";
import { ref, onMounted, watch } from "vue";
import * as homeApi from "@/api/home";
import * as examApi from "@/api/exam";
import { CircleClose } from "@element-plus/icons-vue";
import * as cookie from "@/utils/cookie.js";
import axios from "axios";
import qs from "qs";
import ExamDescDialog from "@/components/ExamDescDialog/index.vue";
import { isPcWeChatBrowser } from "@/utils/utils.js";

const router = useRouter();
const store = useStore();
const route = useRoute();

const asideShow = ref(true);
const aloneShow = ref(false);
const breadList = ref([]);

const advert_show = ref(false);
const advert_time = ref(5);
const isRouterActive = ref(false);

const shanxiDialog = ref(false);
const isHome = (route) => {
  if (route == []) {
    return route.name === "首页";
  }
};
const getBreadcrumb = () => {
  let matched = route.matched;
  if (!isHome(matched[0])) {
    matched = [{ path: "/", meta: { title: "首页" } }].concat(matched);
  }
  breadList.value = matched;
  breadList.value.forEach((item, i) => {
    if (item.meta.title == "" || item.meta.title == undefined) {
      breadList.value.splice(1, i);
    }
  });
};

const userInfoKey = `${process.env.NODE_ENV}_userInfo`;

if (!getCookie(userInfoKey)) {
  console.log("未登录");
} else {
  store.state.userInfo = JSON.parse(getCookie(userInfoKey));
}
watch(
  () => router.currentRoute.value.path,
  (val) => {
    console.log(val);
    console.log("手机", _isMobile());
    if (_isMobile()) {
      if (val == "/sign_detail") {
        window.location.href = `${process.env.VUE_APP_MOBILE_URL}/#/pages/pages_home/courseDetail/courseDetail?courseId=${route.query.courseId}`;
      } else {
        window.location.href = process.env.VUE_APP_MOBILE_URL;
      }
    }
  }
);

const _isMobile = () => {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};

// 监听用户跳转至手机端
if (_isMobile()) {
  window.location.href = process.env.VUE_APP_MOBILE_URL;
}

// 请求 - 验证token是否有效
const verifyToken = async () => {
  const userInfo = store.state.userInfo;
  // 没有token就返回
  if (!userInfo.examToken) {
    localStorage.removeItem("hasOtherCourse");
    return;
  }
  let params = {
    token: encodeURIComponent(userInfo.examToken),
    userId: userInfo.userid,
  };
  try {
    const headers = {
      terminal: 1,
      Authorization: userInfo.ssoToken,
    };
    let { data } = await axios.post(
      `${process.env.VUE_APP_BASE_URL}verifyToken`,
      qs.stringify(params),
      {
        headers,
      }
    );
    if (data.resCode !== 200) {
      // 如果 token 验证失败，删除 用户信息
      cookie.clearCookie("userInfo");
      cookie.clearCookie("token");
      cookie.clearCookie("production_userInfo");
      localStorage.removeItem("hasOtherCourse");
    } else {
      // 用户已登陆
      console.log("用户登录信息正常");
      homeApi.getMyMenuForShanxi({}).then((res) => {
        console.log(res);
        localStorage.setItem("hasOtherCourse", res.resData.hasOtherCourse);
      });
    }
  } catch {}
};

watch(
  () => router.currentRoute.value.path,
  (newValue) => {
    verifyToken();
    if (!getCookie(userInfoKey)) {
      console.log("未登录");
    } else {
      store.state.userInfo = JSON.parse(getCookie(userInfoKey));
    }
    getBreadcrumb();
    console.log(newValue);
    if (newValue == "/" || newValue == "/sign_detail") {
      let advertTimer = null;
      clearInterval(advertTimer);

      advert_time.value = 5;
      advert_show.value = true;
      advertTimer = setInterval(() => {
        advert_time.value--;
        if (advert_time.value <= 0) {
          advert_show.value = false;
          advert_time.value = 5;
          clearInterval(advertTimer);
        }
      }, 1000);
    } else {
      advert_show.value = false;
    }

    if (
      newValue == "/" ||
      newValue == "/home_list" ||
      newValue == "/shanxi_list" ||
      newValue == "/courseDetail"
    ) {
      asideShow.value = false;
    } else {
      asideShow.value = true;
    }
    if (newValue.indexOf("/alone") != -1 || newValue.indexOf("/exam/") != -1 || newValue === "/browser-tip") {
      aloneShow.value = true;
    } else {
      aloneShow.value = false;
    }
    // 面包屑
    switch (newValue) {
      case "/course":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          { path: newValue, meta: { title: "我的课程" } },
        ];
        break;
      case "/course/info":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          { path: newValue, meta: { title: "课程详情" } },
        ];
        break;
      case "/exam_list":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          { path: newValue, meta: { title: "我的考试" } },
        ];
        break;
      case "/result_list":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          { path: newValue, meta: { title: "成绩查询" } },
        ];
        break;
      case "/result_list/result_detail_list":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "成绩查询" },
          },
        ];
        break;
      case "/zs":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "我的证书" },
          },
        ];
        break;
      case "/train_info":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "学员培训记录" },
          },
        ];
        break;
      case "/student_management":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "账号报名记录" },
          },
        ];
        break;
      case "/order":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "订单列表" },
          },
        ];
        break;
      case "/order/confirm":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "确认报名" },
          },
        ];
        break;
      case "/order/certificateInfo":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "确认提交" },
          },
        ];
        break;
      case "/order/weiPay":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "付款" },
          },
        ];
        break;
      case "/order/certificateWeiPay":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "确认提交" },
          },
        ];
        break;
      case "/order/onlinePay":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "付款" },
          },
        ];
        break;
      case "/order/paySuccess":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "付款" },
          },
        ];
        break;
      case "/order/certificatePaySuccess":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "确认提交" },
          },
        ];
        break;
      case "/order/zfbPay":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "付款" },
          },
        ];
        break;

      case "/order/refund":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "退款" },
          },
        ];
        break;

      case "/help":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "帮助中心" },
          },
        ];
        break;
      case "/help/info":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "帮助中心" },
          },
        ];
        break;
      case "/help/touch":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "联系我们" },
          },
        ];
        break;

      case "/message":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "消息中心" },
          },
        ];
        break;
      case "/message/info":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "消息中心" },
          },
        ];
        break;
      case "/sign_detail":
        breadList.value = [
          { path: "/", meta: { title: "首页" } },
          {
            path: newValue,
            meta: { title: "在线报名" },
          },
        ];
        break;
    }
  },
  { immediate: true }
);

const notPayVisible = ref(false);
const listMyOrder = () => {
  const params = {
    orderPayStatus: 0,
    pageSize: 5,
    pageNum: 1,
  };
  homeApi.listMyOrder(params).then((res) => {
    if (res.resCode == 200) {
      if (res.resData == null) {
        notPayVisible.value = false;
      } else {
        if (res.resData.list.length == 0) {
          notPayVisible.value = false;
        } else {
          notPayVisible.value = true;
        }
      }
    }
  });
};

const goOrder = () => {
  notPayVisible.value = false;
  router.push({
    path: "/order",
    query: {
      orderPayStatus: 0,
    },
  });
};

const examInfo = ref("");
const cutVisible = ref(false);
const subVisible = ref(false);
const examLimitSwitchScreenCount = ref(0);
const switchScreenCount = ref(0);
// 监听用户切屏
const cheat = () => {
  if (getCookie("examInfo") && getCookie(userInfoKey)) {
    const userId = JSON.parse(getCookie(userInfoKey)).userid;
    examInfo.value = JSON.parse(getCookie("examInfo"));
    if (examInfo.value.userId == userId) {
      const params = {
        studentId: examInfo.value.signUpUserId,
        examId: examInfo.value.examId,
        paperId: examInfo.value.paperId,
      };
      examApi.getExamPreventionCheatInfo(params).then((res) => {
        console.log("请求考试数据");
        if (res.resCode == 200) {
          if (
            res.resData.isOpenExamPreventionCheat == 1 &&
            res.resData.paperIsSubmit == 0
          ) {
            examApi.addExamPaperSwitchScreenCount(params).then((res) => {
              console.log("请求增加切屏次数");
              if (res.resCode == 200) {
                cutVisible.value = true;
                examLimitSwitchScreenCount.value =
                  res.resData.examLimitSwitchScreenCount;
                switchScreenCount.value = res.resData.switchScreenCount;
                if (
                  examLimitSwitchScreenCount.value <= switchScreenCount.value
                ) {
                  console.log("切屏次数已满");
                  const submitParams = {
                    signUpUserId: examInfo.value.signUpUserId,
                    examId: examInfo.value.examId,
                    paperId: examInfo.value.paperId,
                    isClientAutoSubmit: 1,
                  };

                  examApi.submitExamPaper(submitParams).then((res) => {
                    if (res.resCode == 200) {
                      cutVisible.value = false;
                      subVisible.value = true;
                      window.removeEventListener("blur", cheat);
                      clearCookie("examInfo");
                      sessionStorage.ScoreInfo = JSON.stringify({
                        paperId: examInfo.value.paperId,
                        signUpUserId: examInfo.value.signUpUserId,
                        examId: examInfo.value.examId,
                        courseId: examInfo.value.courseId,
                      });
                      router.push({
                        path: "/exam/score_detail",
                        query: {
                          complain: 1,
                        },
                      });
                    }
                  });
                }
              } else {
                window.removeEventListener("blur", cheat);
                clearCookie("examInfo");
              }
            });
          }
        } else {
          window.removeEventListener("blur", cheat);
          clearCookie("examInfo");
        }
      });
    }
  }
};

onMounted(() => {
  // 进入项目后调用listMyOrder接口，屏蔽错误提示
  homeApi.listMyOrder({}, { skipErrorToast: true }).catch((err) => {
    // 当接口返回401错误时，清空cookies
    if (err && err.resCode === 401) {
      cookie.clearCookie("userInfo");
      cookie.clearCookie("token");
      localStorage.removeItem("hasOtherCourse");
    }
  });
  
  try {
    if (isPcWeChatBrowser() && route.path !== "/browser-tip") {
      // 保存跳转前的路由路径（包括query参数）
      const previousPath = route.fullPath || route.path || "/";
      sessionStorage.setItem("previousRouteBeforeBrowserTip", previousPath);
      // 跳转到浏览器提示页面
      router.push("/browser-tip");
    }
  } catch (e) {}
  try {
    console.log("[PC WeChat Debug] UA =", navigator.userAgent);
    console.log(
      "[PC WeChat Debug] isPcWeChatBrowser() =",
      isPcWeChatBrowser()
    );
  } catch (e) {}
  verifyToken();
  getBreadcrumb();
  let myDate = new Date();
  var nowDate =
    myDate.getFullYear() +
    "-" +
    (myDate.getMonth() + 1) +
    "-" +
    myDate.getDate();
  console.log(nowDate);
  // 需要弹出弹窗
  if (getCookie(userInfoKey)) {
    if (localStorage.getItem("nowDate") != nowDate) {
      localStorage.setItem("nowDate", nowDate);
      listMyOrder();
    }
  }
  // 页面切换监听
  window.addEventListener("blur", cheat, false);
});
</script>
<style lang="scss">
@import "tailwind.css";

.browser-tip-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  overflow: auto;
}

.main-content {
  width: 748px !important;
  min-height: calc(100vh - 216px);
}

.bread {
  width: 100%;
  display: block;
  border-bottom: 1px solid #b7c1cd;
  /* margin-bottom: 20px; */
}

.bread_title {
  line-height: 60px;
  vertical-align: middle;
  padding-right: 6px;
  padding-left: 20px;
}

.bread .el-breadcrumb {
  display: inline-block;
  vertical-align: middle;
  line-height: 60px;
}

.bread .is-link {
  font-weight: normal;
}

.resource_wrap {
  width: 748px;
  height: 500px;
  border: 1px solid #dbdbdb;
}

.advert_mask {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 999;

  .advert_wrap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    display: inline-block;
    width: 610px;
    height: 800px;

    img {
      width: 610px;
    }
  }

  p {
    color: #ffffff;
    font-size: 24px;
    float: right;
  }

  .close {
    font-size: 30px;
    text-align: center;
    color: #ffffff;
    margin-top: 20px;
    cursor: pointer;
  }
}

.shanxi_tip_wrap {
  font-size: 16px;
  line-height: 24px;

  .shanxi_division {
    margin-bottom: 16px;
  }

  p {
    margin-bottom: 4px;
  }

  a {
    display: inline-block;
  }
}
</style>
